import { DataPoint } from 'Interfaces/DataPoint';
import * as React from 'react';
import { Badge, Button } from 'react-bootstrap';

interface Props {
  data: DataPoint[];
}

// type Status = 'assigned' | 'inprogress' | 'removed' | 'done' | 'approved';

interface Count {
  [key: string]: number;
}

export default function TaskStatusCount(props: Props) {

  const [counts, setCounts] = React.useState<Count>({});

  React.useEffect(() => {
    const count = {};
    props.data.forEach(d => {
      if (d.taskstatus) {
        count[d.taskstatus] = count[d.taskstatus] || 0;
        count[d.taskstatus]++;
      }
    });
    setCounts(count);
  }, [props.data]);

  const taskCounts = React.useCallback(() => {
    return Object.keys(counts).map((c => (
      <Button
        key={`task-status-${c}`}
        variant="primary"
        size="sm"
        data-testid={`task-status-${c}`}
      >
        {`${c} `}
        <Badge variant="secondary">{counts[c]}</Badge>
      </Button>
    )));
  }, [counts]);
  return (
    <>{taskCounts()}</>
  );
}
